import React from "react";
import PrivateHeader from "../Components/Private/PrivateHeader";
import PrivateSidebar from "../Components/Private/PrivateSidebar";
import useAuth from "../Context/useAuth";

const PrivateLayout = ({ children }) => {
  const { isSiderbarToggle } = useAuth();
  return (
    <>
      <div className={isSiderbarToggle ? "nav-hidden" : "nav-effect"}>
        <div className="after-login">
          <PrivateHeader />
          <PrivateSidebar />
          {children}
        </div>
      </div>
    </>
  );
};

export default PrivateLayout;
